App.filter('dateComing', function () {
    // @TODO <HEALTH2019>
    return function (ms) {
        if (ms) {
            var now = (new Date()).getTime();
            ms = parseInt(ms);
            return ms < (now + 60 * 1000);
        }
    // @TODO </HEALTH2019>
        return false;
    };
});
